module.exports = __webpack_public_path__ + "img/58.71e36904.png";